export default query => window.matchMedia(query).matches
